import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import Card from '../Card/Card';
import { fundingTypes, accountTypes } from '../../flows/shared/utils';
import DirectIcon from '../../images/direct-rollover.png';

const CheckFundingCard = ({ accountType }) => {
  const { next } = useContext(FlowContext);

  return (
    <Card
      id="CheckFundingCard"
      icon={DirectIcon}
      title={
        accountType === accountTypes.TRUST ? (
          <div>Mail a check</div>
        ) : (
          <div>Check</div>
        )
      }
      subtitle={
        <div>
          You&apos;ll find detailed mailing instructions on the confirmation
          page.
        </div>
      }
      buttonText="Continue"
      buttonFunction={next(fundingTypes.CHECK)}
      buttonID="CheckCardBtn"
    />
  );
};

export default CheckFundingCard;
